import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationFetalLiesList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationFetalLies/GetList?` + params, null);







